var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-slider"},_vm._l((_vm.images),function(image,i){return _c('div',{key:`advert_image_${i}`,staticClass:"image-slider__slide fade"},[_c('img',{staticClass:"listing-image",attrs:{"src":image.imageUrl,"alt":_vm.getAltDescription(image)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }